import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueAnime from 'vue-animejs';
import { library } from '@fortawesome/fontawesome-svg-core';
import SocialSharing from 'vue-social-sharing';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faPlay, faPause, faTh, faShare, faPlayCircle, faPauseCircle,
    faVolumeOff, faVolumeMute, faVolumeDown, faVolumeUp,
    faExpand, faCompress, faTimes, faPaperPlane

} from '@fortawesome/free-solid-svg-icons';
import {
    faFacebook, faLinkedin, faTwitterSquare, faPinterest, faReddit, faSkype
} from '@fortawesome/free-brands-svg-icons';
import {faSpinnerThird} from '@fortawesome/pro-regular-svg-icons';
import VTooltip from 'v-tooltip'
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';

Vue.component('VueSlider', VueSlider);

Vue.use(VTooltip);
Vue.use(VueToast); // https://www.npmjs.com/package/vue-toast-notification

// Font Awesome
library.add(faPlay);
library.add(faPause);
library.add(faTh);
library.add(faShare);
library.add(faPlayCircle); // Big Play
library.add(faPauseCircle); // Big Pause
library.add(faTimes);

// Volume
//library.add(faVolume); Not Found in FA Vue
library.add(faVolumeOff);
library.add(faVolumeMute);
library.add(faVolumeDown);
library.add(faVolumeUp);

// Fullscreen Toggle
library.add(faExpand);
library.add(faCompress);

// Share Icons
library.add(faPaperPlane);
library.add(faFacebook);
library.add(faLinkedin);
library.add(faTwitterSquare);
library.add(faPinterest);
library.add(faReddit);
library.add(faSkype);

// FAR icons must use :icon=['far', 'icon-name'] to import
library.add(faSpinnerThird);


Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueAnime);

Vue.use(SocialSharing);

Vue.config.productionTip = false;


window.vue = new Vue({
  store,
  render: h => h(App)
}).$mount('#app');

window.bus = new Vue();